import React from 'react';
import PublicChrome from './public/PublicChrome';
import BrandKitDisplay from './BrandKitDisplay';

const BrandKitPage: React.FC = () => (
  <PublicChrome>
    <BrandKitDisplay />
  </PublicChrome>
);

export default BrandKitPage;
